import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.BusinessBankStatementManual.title',
        defaultMessage: 'Upload statements manually'
    },
    cta: {
        id: '_.BusinessBankStatementManual.cta',
        defaultMessage: 'Upload statements'
    },
    point1: {
        id: '_.BusinessBankStatementManual.point1',
        defaultMessage:
            'You can download these from your online banking (<a>See instructions</a>)'
    },
    point2: {
        id: '_.BusinessBankStatementManual.point2',
        defaultMessage:
            'Files must be PDF or JPG, JPEG, PNG and no more than 2GB.'
    },
    point3: {
        id: '_.BusinessBankStatementManual.point3',
        defaultMessage:
            'These should be for the account(s) where the majority of your business revenue is generated.'
    },
    point4: {
        id: '_.BusinessBankStatementManual.point4',
        defaultMessage:
            'Please ensure the statements display the business name, sort code, account number and the account balance.'
    },
    point5: {
        id: '_.BusinessBankStatementManual.point5',
        defaultMessage:
            'The accounts must contain at least the most recent transactions in the last 90 days.'
    },
    point6: {
        id: '_.BusinessBankStatementManual.point6',
        defaultMessage:
            'The accounts must contain at least the most recent transactions in the last 90 days.'
    },
    howToDownloadBankStatement: {
        id: '_.BusinessBankStatementManual.howToDownloadBankStatement',
        defaultMessage:
            '<a>See how</a> to download your online banking statements.'
    },
    cannotLinkAccount: {
        id: '_.BusinessBankStatements.cannot_link_account',
        defaultMessage:
            'If you prefer, you can upload your latest 6 months of bank statements'
    },
    selectManualReasonText: {
        id: '_.BusinessBankStatements.select_manual_reason_text',
        defaultMessage:
            'Select an option below to manually upload bank statements'
    }
});
